<template>
  <section class="relative bg-white ">
    <nuxt-img class="absolute inset-0 w-full h-full md-max:object-cover" width="1024" height="787" loading="lazy"
      format="webp" sizes="xs:340px sm:440px md:768px lg:1024px xl:1024px 2xl:1024px" :src="backgroundImage"
      alt="background" />

    <div
      class="relative z-20 items-center max-w-screen-xl gap-8 px-4 py-8 mx-auto 2xl:px-0 bg-glassmorhpism lg:grid lg:grid-cols-2 xl:gap-16 lg:py-16 lg:px-6 ">
      <nuxt-img class="w-full mb-4 rounded-lg lg:mb-0" width="400" height="560" loading="lazy" alt="top-influencers"
        format="webp" sizes="sm:300px md:400px lg:400px xl:400px" :src="mainImage" />

      <div>
        <h2 class="mb-4 font-extrabold text-center h2 md:text-left" v-html="mainTitle"></h2>
        <div class="py-4 border-t border-b lg:py-8 lg:pt-0 border-lifeboost-orange-middle">
          <div v-for="(benefit, index) in benefits" :key="index" class="flex pt-4 lg:pt-8"
            :class="{ 'pt-0': index === 0 }">
            <div class="flex items-center justify-center w-8 h-8 mr-4 rounded-full bg-primary-100 shrink-0">
              <nuxt-img class="w-10 h-10 text-primary-600 " width="40" height="40" loading="lazy" format="webp"
                :alt="benefit.iconAlt" :src="benefit.iconSrc"></nuxt-img>
            </div>
            <div>
              <h3 class="mb-2 font-bold text-gray-900 h4" v-html="benefit.title"></h3>
              <p class="mb-2 textp" v-html="benefit.description"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const props = defineProps({
  backgroundImage: {
    type: String,
    default: "assets/images/bg-latte.png"
  },
  mainImage: {
    type: String,
    default: "/assets/images/imagemushroom.png"
  },
  mainTitle: {
    type: String,
    default: "Transformative Daily Benefits:"
  },
  benefits: {
    type: Array,
    default: () => [
      {
        iconSrc: "/assets/images/ICON-MORNING_ROUTINE_REVOLUTION.svg",
        iconAlt: "Morning Routine Revolution",
        title: "Morning Routine Revolution",
        description: "Begin your day on the right note, engaging in your rituals with a coffee that's as stomach-friendly as it is energizing."
      },
      {
        iconSrc: "/assets/images/ICON-PRODUCTIVITY-UNLEASHED.svg",
        iconAlt: "Productivity Unleashed",
        title: "Productivity Unleashed",
        description: "Harness extended focus and creativity in your work, powered by the cognitive support of Lion's Mane."
      },
      {
        iconSrc: "/assets/images/ICON-EMPOWERED-IMMUNITY.svg",
        iconAlt: "Empowered Immunity",
        title: "Empowered Immunity",
        description: "Navigate your day with confidence, backed by the immune-boosting powers of Chaga mushroom."
      },
      {
        iconSrc: "/assets/images/ICON-LIFETIME-OF-LEARNING.svg",
        iconAlt: "Lifetime of Learning",
        title: "Lifetime of Learning",
        description: "Fuel your brain’s natural ability for continuous growth and knowledge acquisition, making every lesson, whether professional or personal, stick."
      }
    ]
  }
});

defineBuilderComponent({
  friendlyName: "ImageFeatureList",
  inputs: [
    {
      name: "backgroundImage",
      type: "file",
      allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
      defaultValue: "assets/images/bg-latte.png"
    },
    {
      name: "mainImage",
      type: "file",
      allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
      defaultValue: "/assets/images/imagemushroom.png"
    },
    {
      name: "mainTitle",
      type: "richText",
      defaultValue: "Transformative Daily Benefits:"
    },
    {
      name: "benefits",
      type: "list",
      subFields: [
        {
          name: "iconSrc",
          type: "file",
          allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
          defaultValue: "/assets/images/ICON-MORNING_ROUTINE_REVOLUTION.svg"
        },
        {
          name: "iconAlt",
          type: "text",
          defaultValue: "Morning Routine Revolution"
        },
        {
          name: "title",
          type: "richText",
          defaultValue: "Morning Routine Revolution"
        },
        {
          name: "description",
          type: "richText",
          defaultValue: "Begin your day on the right note, engaging in your rituals with a coffee that's as stomach-friendly as it is energizing."
        }
      ],
      defaultValue: [
        {
          iconSrc: "/assets/images/ICON-MORNING_ROUTINE_REVOLUTION.svg",
          iconAlt: "Morning Routine Revolution",
          title: "Morning Routine Revolution",
          description: "Begin your day on the right note, engaging in your rituals with a coffee that's as stomach-friendly as it is energizing."
        },
        {
          iconSrc: "/assets/images/ICON-PRODUCTIVITY-UNLEASHED.svg",
          iconAlt: "Productivity Unleashed",
          title: "Productivity Unleashed",
          description: "Harness extended focus and creativity in your work, powered by the cognitive support of Lion's Mane."
        },
        {
          iconSrc: "/assets/images/ICON-EMPOWERED-IMMUNITY.svg",
          iconAlt: "Empowered Immunity",
          title: "Empowered Immunity",
          description: "Navigate your day with confidence, backed by the immune-boosting powers of Chaga mushroom."
        },
        {
          iconSrc: "/assets/images/ICON-LIFETIME-OF-LEARNING.svg",
          iconAlt: "Lifetime of Learning",
          title: "Lifetime of Learning",
          description: "Fuel your brain’s natural ability for continuous growth and knowledge acquisition, making every lesson, whether professional or personal, stick."
        }
      ]
    }
  ]
});
</script>